<template lang="pug">
v-card.overflow-hidden.elevation-0
  v-dialog(v-model='isModalEditarEstado'  max-width='450')
    v-card.pa-3
      .flex-1
        v-card-title.pa-3.pl-4
          span.font-weight-700(:class="{'font-size-17' : isMovil}") {{indexEstadoSeleccionado ? 'Editar estado' : 'Nuevo estado'}}
        v-card-subtitle.pb-3.font-size-12 Los cambios que se realicen afectaràn en todo las secciones usadas (filtros, procesos node-cron, listas y notificaciones por email)
        .pa-4
          v-text-field.mb-6(v-if="indexEstadoSeleccionado" hide-details v-model='estadoEditar.codigo ' ref="codigoModal"  dense :label="`Codigo estado  `" disabled)
          v-text-field.mb-6( hide-details v-model='estadoEditar.descripcion' ref="tituloModal"  dense :label="`Nombre estado  `" )
          v-text-field.mb-6( hide-details v-model='estadoEditar.accion' ref="accionModal"  dense :label="`Accion  `" )
          v-select(
            :loading="isLoadingEtapas"
            hide-details
            :items='etapasEstados'
            v-model="estadoEditar.etapa"
            label='Etapa del estado'
            dense=''
            item-text="descripcion"
            item-value="id"
          )
          v-checkbox.mb-4(v-model="estadoEditar.cerrado" color='primary'  hide-details, label="Este estado cierra el ticket")
          v-card.my-1(v-if="estadoEditar.icono")
            v-img(
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1),#161f2b85"
              :src="estadoEditar.icono",
              max-height="150"
              content
            )
              .d-flex
                v-spacer
                small.px-4.py-2.font-size-11.text-muted {{estadoEditar.icono}}

          v-file-input.mt-2(
            v-model='estadoEditar.iconoCambiar'
            color='primary'
            prepend-icon=""
            :label="indexEstadoSeleccionado ? 'Seleccionar para cambiar el icono' : 'Seleccionar para agregar icono'"
            placeholder='Seleccione el archivo'
            outlined=''
            hide-details
            :show-size='1000'
          )
            template(v-slot:selection='{ index, text }')
              v-chip( color='primary' dark=''  label='' small='')
                | {{ text }}
      v-card-actions.mt-3
        v-spacer
        v-btn.mr-1(color='ligth' small @click='closeDialogEditar')
          | cancelar
        v-btn(color='success' small @click='fetchGuardarEstado()')
          | {{indexEstadoSeleccionado ? 'Guardar cambios' : 'Generar estado'}}
  .d-flex
    .flex-1
      v-card-title
        span.font-weight-700 Estados
      v-card-subtitle.font-size-12.pb-1 Administrador de estados
    v-btn.ma-5.mr-3( color="primary" small fab='' @click="fetch('garantia')")
      v-icon sync
    v-btn.mt-5.mr-3( color="success" small fab='' @click="openDialogEditar({}, '')")
      v-icon add
  v-card-title.pt-0
    v-select(
      hide-details
      :items="listadoTiposEstado"
      v-model="tipoEstado"
      label='Seleccionar '
      @change="fetch()"
      item-value="code"
      item-text="name"
      dense=''
      solo=''
    )
  v-sheet.overflow-y-auto
    v-card.elevation-0(height="calc(100vh - 298px)" )
      lista-draggable(v-model="estados"  :options="{handle:'.handle'}" ghost-class="ghost" chosen-class="chosen" drag-class="drag")
        v-list.pa-0(nav='' dense='' v-for='(item, i) in estados' :key='i')
          v-list-item.mx-1
            v-list-item-content.py-0
              v-list-item-title
                .d-flex
                  .flex-1
                    span.font-weight-700 {{item.orden}} &nbsp; -
                    span.font-size-12 &nbsp; {{item.descripcion}} ({{item.codigo}})
                  v-chip(label color="background", v-if="item.cerrado")
                    | Cierra el ticket

              //- v-list-item-subtitle codigo {{item.codigo}}
            v-list-item-icon.handle
              v-btn.mx-2(fab='' dark='' x-small='' color='info' @click="openDialogEditar(item, i)")
                v-icon(dark='')
                  | edit

            v-list-item-icon.handle
              v-icon(color="background", size="30") drag_indicator
          v-divider
  v-card.elevation-0
    v-card-text.pa-3
      .d-flex
        small.text-muted.font-size-11(v-if="!isMovil") Mostrando {{estados.length}} estados
        v-spacer
        v-btn(:block="isMovil" color="success",  :small="!isMovil" @click="fetchReordenarEstados()")
          | Reordenar estados
</template>
<script>
import { apiGet, apiPost, notify, apiUploadWithParams } from '../util/general'
import draggable from 'vuedraggable'
export default {
  components : {
    'lista-draggable' : draggable
  },
  data () {
    return {
      isModalEditarEstado: false,
      estados            : [],
      filtered           : [],
      ordersEstados      : [],
      tipoEstado         : 'garantia',
      estadoEditar       : {
        codigo      : 0,
        descripcion : '',
        accion      : '',
        etapa      : '',
        cerrado     : false,
        orden       : '',
        tipo        : '',
        icono       : '',
        iconoCambiar: null
      },
      etapasEstados          : [],
      indexEstadoSeleccionado: '',
      apiUpload              : process.env.API_UPLOAD_ROUTE,
      isLoadingEtapas        : false,
      listadoTiposEstado : [
        {
          name : 'Garantia',
          code : 'garantia'
        },
        {
          name : 'Solicitud de insumo',
          code : 'solicitud de insumo'
        },
        {
          name : 'Incidencia con equipo',
          code : 'incidencia con equipo'
        }
      ]
    }
  },
  created () {
    var vm = this
    vm.fetch()
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods : {
    fetchUploadFile (file, callback) {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Guardando icono para estado' })
      var fd = new FormData()
      var url = `${vm.apiUpload}/upload`
      fd.append('file', file)
      var params = {
        carpeta: 'img-estados',
        usuario: localStorage.getItem('usuario')
      }

      apiUploadWithParams(vm, url, fd, params,  res => {
        console.log('termino guardar')
        callback(null, res)
      }, err => {
        vm.$store.dispatch('transaccion', { isProceso : false })
        callback(err)
      })
    },
    openDialogEditar (e, i) {
      var vm = this
      vm.estadoEditar.descripcion = e.descripcion || ''
      vm.estadoEditar.accion = e.accion || ''
      vm.estadoEditar.codigo     = e.codigo || 0
      vm.estadoEditar.etapa     = e.etapa || 0
      vm.estadoEditar.cerrado    = e.cerrado || false
      vm.estadoEditar.orden      = e.orden || ''
      vm.estadoEditar.icono      = e.icono || ''
      vm.estadoEditar.iconoCambiar  = null
      vm.indexEstadoSeleccionado = i
      vm.isModalEditarEstado = true;
      vm.fetchEtapa()
    },
    closeDialogEditar () {
      var vm                             = this
      vm.indexEstadoSeleccionado         = ''
      vm.estadoEditar.codigo             = 0
      vm.estadoEditar.etapa             = 0
      vm.estadoEditar.descripcion        = ''
      vm.estadoEditar.accion             = ''
      vm.estadoEditar.icono              = ''
      vm.estadoEditar.iconoCambiar       = null
      vm.estadoEditar.cerrado            = 0
      vm.estadoEditar.orden              = ''
      vm.isModalEditarEstado             = false;
    },
    fetchGuardarEstado () {
      var vm = this
      if (vm.indexEstadoSeleccionado === '' && !vm.estadoEditar.descripcion) {
        notify(vm, 'error', 'Error', 'Ingrese un titulo para el estado')
        return
      }

      if (vm.indexEstadoSeleccionado === '' && !vm.estadoEditar.accion) {
        notify(vm, 'error', 'Error', 'Ingrese una descripcion para la accion  del estado')
        return
      }

      if (vm.indexEstadoSeleccionado === '' && !vm.estadoEditar.etapa) {
        notify(vm, 'error', 'Error', 'Seleccione una etapa para el estado')
        return
      }

      if (vm.indexEstadoSeleccionado === '' && !vm.estadoEditar.iconoCambiar) {
        notify(vm, 'error', 'Error', 'Seleccione un icono para las notificaciones ')
        return
      }

      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Guardar datos de estado' })
      vm.estadoEditar.tipo = vm.tipoEstado.toLowerCase()

      if (vm.indexEstadoSeleccionado !== '') {
        var obj = {
          codigo: vm.estadoEditar.codigo,
          datos : vm.estadoEditar
        }
        apiPost(vm, '/estado/guardar', obj, function (data) {
          if (vm.estadoEditar.iconoCambiar) {
            vm.fetchUploadFile(vm.estadoEditar.iconoCambiar, (err, res) => {
              if (err) {
                vm.$store.dispatch('transaccion', { isProceso : false })
                notify(vm, 'error', 'Error', err.message)
                return
              }

              var obj = {
                codigo: vm.estadoEditar.codigo,
                datos : { ...vm.estadoEditar, icono : res.ruta }
              }

              apiPost(vm, '/estado/guardar', obj, function (data) {
                notify(vm, 'success', 'Exito', 'Los datos se guardaron correctamente')
                vm.closeDialogEditar()
                vm.fetch()
              }, function (error) {
                notify(vm, 'error', 'Error', error.message)
              }, function () {
                vm.$store.dispatch('transaccion', { isProceso : false })
              })
            })
          } else {
            notify(vm, 'success', 'Exito', 'Los datos se guardaron correctamente')
            vm.$store.dispatch('transaccion', { isProceso : false })
            vm.closeDialogEditar()
            vm.fetch()
          }
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
          vm.$store.dispatch('transaccion', { isProceso : false })
        })
      } else {
        vm.fetchUploadFile(vm.estadoEditar.iconoCambiar, (err, res) => {
          if (err) {
            notify(vm, 'error', 'Error', err.message)
            return
          }

          var obj = {
            codigo: vm.estadoEditar.codigo,
            datos : { ...vm.estadoEditar, icono : res.ruta }
          }

          apiPost(vm, '/estado/guardar', obj, function (data) {
            notify(vm, 'success', 'Exito', 'Los datos se guardaron correctamente')
            vm.closeDialogEditar()
            vm.fetch()
          }, function (error) {
            notify(vm, 'error', 'Error', error.message)
          }, function () {
            vm.$store.dispatch('transaccion', { isProceso : false })
          })
        })
      }
    },
    fetchReordenarEstados () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Reordenar estados' })
      vm.estadoEditar.tipo = vm.tipoEstado.toLowerCase()
      var obj = {
        tipo : vm.tipoEstado,
        lista: vm.estados
      }
      apiPost(vm, '/estado/reordenar', obj, function (data) {
        notify(vm, 'success', 'Exito', 'Los datos se guardaron correctamente')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetch () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener listado de estados' })
      var obj = {
        tipo : vm.tipoEstado
      }
      apiGet(vm, '/estado/obtener', obj, function (data) {
        vm.estados  = data.lista
        vm.filtered = vm.estados
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchEtapa () {
      var vm = this
      vm.isLoadingEtapas  = true
      var obj = {
        tipo : vm.tipoEstado
      }
      apiGet(vm, '/estado/obtener/etapas', obj, function (data) {
        vm.etapasEstados  = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingEtapas  = false
      })
    },
    buscarValor (value) {
      var vm = this
      if (value) {
        vm.estados = vm.filtered
        vm.estados = vm.estados.filter(e => {
          e.codigo += ''
          return e.codigo.toLowerCase().includes(value.toLowerCase()) || e.descripcion.toLowerCase().includes(value.toLowerCase())
        })
      } else vm.estados = vm.filtered
    }
  }
}
</script>
<style lang="stylus" scoped>
.chosen
  opacity      : 0.6
  background   : #ebeff3;
  border-radius: 0;
  transition   : background-color 0.25s, border-radius 0.25s;
.handle
  cursor: move;
</style>



// WEBPACK FOOTER //
// View_administrador_estados.vue?73f2052c